import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { CourseService } from 'src/app/services/course.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-qr-modal',
  templateUrl: './qr-modal.component.html',
  styleUrls: ['./qr-modal.component.scss']
})
export class QrModalComponent implements OnInit {

  @Input() org: any;
  qrUrl: string | null = null;
  showQr: boolean = false;
  qr_form: FormGroup;
  submit_qr: boolean = false;
  submitted = false;
  loader = false;

  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private course_service: CourseService,
    private ns: NotificationService,
  ) { }
  ngOnInit() {

    this.qr_form = this.fb.group({
      page: ['', Validators.required]
    });
  }

  onPageChange() {
    this.qrUrl = null;
    this.showQr = false;
  }

  downloadQR() {
    fetch(this.qrUrl).then(res => res.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'qr-code.png';
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  generateQRCode() {
    this.submit_qr = true;

    if (this.qr_form.invalid) {
      this.qr_form.markAllAsTouched();
      return;
    }
    const payload = {
      ...this.org,
      page: this.qr_form.value.page
    }


    this.loader = true;
    this.course_service.generate_org_qrcode(payload)
      .pipe(finalize(() => {
        this.loader = false;
      })).subscribe(res => {
        this.ns.showNotification('success', "QR-Code generated successfully");
        this.qrUrl = res.data.s3_link;
        this.showQr = true;
      })
  }
}
